export default () => ({
    height: '100%',
});
